export default function ({ store, redirect }) {
    // If the user is not authenticated
    if (!store.getters['auth/loggedIn']) {
        return redirect('/login')
    }

    store.dispatch('auth/setAuthHeader', store.state.auth.token)
}
